// @flow
export const SimpleFormFieldVariables = {
  errorColor: '--rp-form-field-error-color',
};

const Vars = SimpleFormFieldVariables;

export const SimpleFormFieldDefaults = {
  [Vars.errorColor]: '#ea4c5b',
};
